//* 组件库
import type { UiTypes, UiTableOption2 } from "various-ui";

export const useOptions = () => {
    //* 获取i18n
    const i18n = useI18n();

    return {
        //* 表格配置
        view: <UiTableOption2[]>[
            { name: "#", key: "index", align: "center" },
            { name: i18n.t("Transcript"), key: "id_mrna", align: "singularity" },
            { name: i18n.t("Length") + "(nt)", key: "size_mrna", align: "center", sort: true },
            { name: i18n.t("ExonCount"), key: "exon", align: "center", sort: true },
            { name: "CDS(bp)", key: "cds", align: "center", sort: true },
            { name: i18n.t("Protein"), key: "id_protein", align: "singularity" },
            { name: i18n.t("Length") + "(aa)", key: "size_protein", align: "center", sort: true },
        ],

        //* 模式配置
        modes: <UiTypes.candidate[]>[
            { label: i18n.t("TableView"), value: "table" },
            { label: i18n.t("TiledView"), value: "visual" },
        ],
    };
};
